import axiosClient from "./axiosClient";

export const getDashboardService = (urlString) => {
    const { route } = urlString;
    return axiosClient.get(
        route);
}

export function generateExcel(data) {
  return axiosClient.post(
    "/payroll_new/gen",
    data,
    { responseType: "blob" }
  );
}


export function generateCSV(data) {
  return axiosClient.post(
    "/payroll_new/report/csv",
    data,
    { responseType: "blob" }
  );
}
